// extracted by mini-css-extract-plugin
export default {"button":"GoogleDataAccess_button__tgFne","iconButton":"GoogleDataAccess_iconButton__nDZ3l"};